export default __webpack_public_path__ + "static/media/LandBeforeTime_03.8053997d.png";